export enum ClientCabinetType {
  SberBank = 'sb',
  BankRossii = 'abr',
  AlfaBank = 'af',
  TBank = 'tb',
  VTB = 'vtb',
  RaiffeisenBank = 'rf',
  CentralBank = 'cbr',
}

export const CABINET_TYPES = Object.values(ClientCabinetType);

export const AVAILABLE_CABINET_TYPES: ClientCabinetType[] = [
  ClientCabinetType.SberBank
];

export enum ClientCabinetCardType {
  Mir = 'mir',
  Visa = 'visa',
  MasterCard = 'mastercard'
}

export enum ClientCabinetCardClass {
  Debit = 'debit',
  Credit = 'credit',
}

export enum ClientCabinetCurrency {
  Rub = 'rub',
  Usd = 'usd',
  Eur = 'eur',
}
